import React from "react";
import Layout from "../../Components/Global/Layout";
import BreadCrumb from '../../Components/Global/BreadCrumb/BreadCrumb';
import AddOrder from '../../Components/OrdersForMultipleAddress/AddOrder/AddOrder';
import { useStore } from "../../Utils/utils";
import { select_store_message } from "../../Constants/Messages"

const AddOrdersPage = () => {
    const { store, setStore } = useStore()

    let select_store = store?.id == null || store?.id == undefined || store?.id == 0 || store?.name == "Global Admin" ? true : false
    return (
        <Layout>
            <div className="breadcrumb-wrapper breadcrumb-contacts">
                <div className="d-flex flex-column">
                    <BreadCrumb />
                </div>
            </div>
            {/* create order using add order */}
            {select_store ?
                <div className="card">
                    <div className="card-body select_store">
                        <p className="text-center">{select_store_message?.select_store}</p>
                    </div>
                </div>
                :
                <AddOrder />
            }

        </Layout>
    )
}
export default AddOrdersPage;

